<div class="container">
  <h6>404</h6>
  <p class="notification-title">Este contenido no está en nuestro sistema.</p>
  <p (click)="closeMapAside()" class="link-text">
    Cerrar el mapa y volver a intentarlo
  </p>
  <div class="image-container">
    <img
      class="image"
      src="https://i.imgur.com/3J6jLjw.gif"
      width="200"
      height="200"
      decoding="async"
      loading="lazy"
      alt="Not found variant"
    />
  </div>
</div>
